import { Reveal } from "./Reveal";
import { useLang } from "../i18n";

const CHAPTERS = [
  {
    num: "01",
    title: "Darshan Ready",
    hindi: "दर्शन",
    image: "/images/marigold.jpg",
    alt: "Marigold garlands outside a Vrindavan temple",
    text: "Wake up in Chaitanya Vihar and walk into the bhav of Braj. Banke Bihari Ji, Prem Mandir, ISKCON and Nidhivan are all a short ride away — we help you plan mangala aarti mornings and evening darshan without the rush.",
  },
  {
    num: "02",
    title: "Seva Bhav",
    hindi: "सेवा",
    image: "/images/exterior.jpg",
    alt: "Shri Jamuna Dham guest house exterior at dusk",
    text: "Hot water on tap, crisp linen, Smart TV and room service that treats you like family, not a booking ID. Every corner is cleaned and prepared the way we would for a guest in our own home — atithi devo bhava.",
  },
  {
    num: "03",
    title: "Sattvic Bhojan",
    hindi: "भोजन",
    image: "/images/food-thali.jpg",
    alt: "Pure vegetarian Vrindavan thali served at Shri Jamuna Dham",
    text: "Our kitchen is 100% pure vegetarian, cooked in the sattvic tradition of Vrindavan — bedmi kachori, creamy lassi in kulhads, and thalis that taste like prasad. Jain and no onion-garlic preparations on request, served hot in your room.",
  },
];

export const Manifesto = () => {
  const { s } = useLang();
  const chapters = CHAPTERS.map((c, i) => ({ ...c, ...s.about.chapters[i] }));
  return (
  <section id="about" className="relative bg-cream py-24 sm:py-32 overflow-hidden" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-peacock font-semibold" data-testid="about-overline">
          {s.about.overline}
        </p>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-maroon tracking-tight max-w-3xl" data-testid="about-heading">
          {s.about.heading}
        </h2>
      </Reveal>

      <div className="mt-20 space-y-24 sm:space-y-32">
        {chapters.map((c, i) => (
          <div
            key={c.num}
            className={`relative grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center ${
              i % 2 === 1 ? "" : ""
            }`}
            data-testid={`manifesto-chapter-${c.num}`}
          >
            <span
              aria-hidden="true"
              className={`pointer-events-none select-none absolute -top-16 font-display font-black text-[10rem] sm:text-[14rem] leading-none text-maroon/[0.06] ${
                i % 2 === 1 ? "right-0" : "left-0"
              }`}
            >
              {c.num}
            </span>

            <Reveal className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <div className="group relative overflow-hidden rounded-2xl">
                <img
                  src={c.image}
                  alt={c.alt}
                  loading="lazy"
                  className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-night/45 via-transparent to-transparent" />
                <span className="absolute bottom-5 left-5 font-hindi text-3xl text-cream drop-shadow-lg">
                  {c.hindi}
                </span>
              </div>
            </Reveal>

            <Reveal delay={0.15} className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <p className="font-display text-sm text-saffron font-semibold tracking-[0.3em]">
                {s.about.chapterWord} {c.num}
              </p>
              <h3 className="mt-3 font-display text-3xl sm:text-4xl font-bold text-ink tracking-tight">
                {c.title}
              </h3>
              <p className="mt-5 text-stone2 text-base sm:text-lg leading-relaxed max-w-xl">
                {c.text}
              </p>
            </Reveal>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};
